import { useNavigate } from "react-router";
import { ShieldAlert } from "lucide-react";
import { usePermissions } from "../../hooks/usePermissions";

export default function NoPermission() {
    const navigate = useNavigate();
    const { getFirstAvailableRoute } = usePermissions();

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-100 dark:bg-gray-900 px-4">
            <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-xl dark:bg-gray-800">
                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/30">
                    <ShieldAlert className="h-8 w-8 text-orange-600 dark:text-orange-400" />
                </div>

                <h2 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white">
                    Sem Permissão
                </h2>

                <p className="mb-6 text-gray-600 dark:text-gray-400">
                    Você não tem permissão para acessar esta página. Entre em contato com o administrador da empresa para solicitar acesso.
                </p>

                <button
                    onClick={() => navigate(getFirstAvailableRoute(), { replace: true })}
                    className="w-full rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700"
                >
                    Ir para Página Inicial
                </button>
            </div>
        </div>
    );
}
